import  UserCreate from './user/create';
import User from './user/index';
import BindGroup from './user/bind_group';
import PasswdReset from './user/reset';
import ExportHistory from './export/index';
import LoanFile from './loan/index';
import LoanSingleUpdate from './loan/signle';
import SearchItem from './search/index';
import OperationLogs from './operation/index';
import Group from './group/index';
import GroupEdit from './group/edit';
import GroupCreate from './group/create';
import DeviceFinance from './device_finance/index';
import Role from './role/index';
import RoleEdit from './role/edit';
import RoleCreate from './role/create';
//import Perm from './perm/index';
import BindPerm from './role/bind_perms';
import Device from './device/index';
import GroupCustom  from './group/custom';
import GroupRole from './group/role';
import Custom from './customs/index';
import CustomCreate from "./customs/create";
import CustomEdit from './customs/edit';
import CustomApp from './customs/app';
import DashBoardIndex from './dashboard/index';
import DashBoardActivation from './dashboard/activation';
import DashBoardActivity from './dashboard/activity';
import DashBoardBattery from './dashboard/dashboard';
import DashBoardNfc from './dashboard/info';
import DeviceCreate from './loan/create';
import DeviceEdit from './device/edit';
import ClearActivation from './management/clear_activation';
import DeviceExport from './search/export';




export default {
    UserCreate,
    ExportHistory,
    LoanFile,
    LoanSingleUpdate,
    SearchItem,
    OperationLogs,
    User,
    PasswdReset,
    Group,
    GroupEdit,
    GroupCreate,
    GroupRole,
    DeviceFinance,
    Role,
    RoleEdit,
    RoleCreate,
 //  Perm,
    BindPerm,
    Device,
    DeviceEdit,
    GroupCustom,
    Custom,
    CustomCreate,
    CustomEdit,
    CustomApp,
    DashBoardIndex,
    DeviceCreate,
    DashBoardNfc,
    DashBoardBattery,
    DashBoardActivation,
    DashBoardActivity,
    BindGroup,
    ClearActivation,
    DeviceExport,
}